module.exports = __webpack_public_path__ + "static/media/eams-logo.3e23942b.png";